'use client'

import { useEffect, useRef, useState } from 'react'
import { seoHtml } from '@/data/homepage'

export default function SEOContentSection() {
  const scrollRef = useRef<HTMLDivElement>(null)
  const [scrolling, setScrolling] = useState(false)
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    const el = scrollRef.current
    if (!el) return

    const onScroll = () => {
      setScrolling(true)
      if (timerRef.current) clearTimeout(timerRef.current)
      timerRef.current = setTimeout(() => setScrolling(false), 900)
    }

    el.addEventListener('scroll', onScroll, { passive: true })
    return () => {
      el.removeEventListener('scroll', onScroll)
      if (timerRef.current) clearTimeout(timerRef.current)
    }
  }, [])

  return (
    <section className="py-6 md:py-8 bg-gradient-to-b from-gray-50 to-white">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden">
          <div
            ref={scrollRef}
            className={`homepage-ai-summary max-h-[170px] md:max-h-[200px] overflow-y-auto px-4 md:px-6 py-3.5 seo-content-wrapper seo-scroll ${
              scrolling ? 'seo-scroll-active' : ''
            }`}
            dangerouslySetInnerHTML={{ __html: seoHtml }}
          />
        </div>
      </div>
    </section>
  )
}
